import React from 'react'
import './form-text.scss'

/**
 * The props
 */
export interface FormTextProps {
    /**
     * The value
     */
    value: string
    
    /**
     * The callback when the value changes
     */
    onChange: (value: string) => void

    /**
     * The callback for when the input blurs out
     */
    onBlur?: () => void

    /**
     * The callback for when the element is blurred
     * with an empty string as value.
     * 
     * This is used for `FormNumber`, so the value can be
     * reset to 0.
     */
    onBlurWithEmptyString?: () => void

    /**
     * Whether or not the input is multiline
     * TODO
     */
    multiline?: boolean
    
    /**
     * A RegExp to check whether the value is valid
     */
    isValid?: RegExp
}

/**
 * The state
 */
export interface FormTextState {
    /**
     * The value
     */
    value: string
}

/**
 * Modify a text value in a form.
 * 
 * @author Stan Hurks
 */
export default class FormText extends React.Component<FormTextProps, FormTextState> {

    constructor(props: FormTextProps) {
        super(props)

        this.state = {
            value: props.value
        }
    }

    public componentWillReceiveProps = () => {
        setTimeout(() => {
            this.setState({
                value: this.props.value
            })
        })
    }

    public render = () => {
        return (
            <div className="form-text">
                <input
                    className="form-text-input"
                    type="text"
                    value={this.props.value}
                    onChange={(event) => {
                        // Don't do anything if the string is invalid
                        if (this.props.isValid && !this.props.isValid.test(event.target.value)) {
                            return
                        }

                        // Perform the change
                        this.props.onChange(event.target.value)
                    }}
                    onBlur={() => {
                        if (this.props.onBlurWithEmptyString && this.state.value === '') {
                            this.props.onBlurWithEmptyString()
                        }
                        if (this.props.onBlur) {
                            this.props.onBlur()
                        }
                    }} />
            </div>
        )
    }
}